import { useLayoutEffect, useRef, useState } from "react";

export const useElementSize = () => {

  const ref = useRef<HTMLElement | null>(null);
  const [ size, setSize ] = useState<{ width: number, height: number }>();

  useLayoutEffect(() => {
    if (!ref.current)
      return;

    const update = () => setSize({ width: ref.current!.offsetWidth, height: ref.current!.offsetHeight });
    const observer = new ResizeObserver(update);
    observer.observe(ref.current);
    update();

    return () => observer.disconnect();
  }, []);

  return { ref, size };

}
